/**
 * Значок типа файла из библиотеки платформы (папка icons/ в корне репозитория).
 *
 * Значки подхватываются по имени файла: положили в папку docx.svg — и
 * <FileIcon type="docx" /> заработал без правки кода. Поэтому тип здесь —
 * обычная строка, а не перечисление, которое пришлось бы дописывать вручную
 * вслед за каждым новым файлом.
 */
const ICONS = import.meta.glob<string>('../../../../icons/*.svg', {
  eager: true,
  query: '?url',
  import: 'default',
});

const URL_BY_TYPE = new Map(
  Object.entries(ICONS).map(([path, url]) => [
    path.slice(path.lastIndexOf('/') + 1, -'.svg'.length).toLowerCase(),
    url,
  ]),
);

interface Props {
  /** Имя файла значка без расширения: xls, pdf, csv, doc… */
  type: string;
  /** Сторона значка в пикселях. 18 — под строку меню и кнопку. */
  size?: number;
  /**
   * Класс от родителя. Меню и кнопки antd передают через него отступ между
   * значком и подписью — без него значок прилипает к тексту.
   */
  className?: string;
}

export function FileIcon({ type, size = 18, className }: Props) {
  const url = URL_BY_TYPE.get(type.toLowerCase());
  // Значка с таким именем в библиотеке нет — место остаётся пустым, а не
  // занято «битой картинкой».
  if (!url) return null;

  return (
    <img
      src={url}
      className={className}
      width={size}
      height={size}
      // Значок дублирует подпись рядом с ним — для экранного чтеца он лишний.
      alt=""
      aria-hidden
      style={{ display: 'inline-block', verticalAlign: '-0.2em', flex: 'none' }}
    />
  );
}
